module.exports = {"130921100":"旧州镇","130921101":"兴济镇","130921102":"杜生镇","130921103":"崔尔庄镇","130921200":"薛官屯乡","130921201":"捷地回族乡","130921202":"张官屯乡","130921203":"李天木回族乡","130921204":"风化店乡","130921205":"姚官屯乡","130921206":"杜林回族乡","130921207":"汪家铺乡","130921208":"刘家庙乡","130921209":"仵龙堂乡","130921210":"大官厅乡","130921211":"高川乡","130921212":"黄递铺乡","130921213":"大褚村回族乡","130921214":"纸房头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130921.json
// module id = 215
// module chunks = 0